// extracted by mini-css-extract-plugin
export default {"zoomModal":"E4-z"};